import { makeStyles } from "@mui/styles";
import styled from "styled-components";

export const config = {
  root: {},
};

export const CardContainer = styled.div`
  position: relative;
  border-radius: 6px;
  // box-shadow: 0px 0px 4px 1px rgb(0 0 0 / 8%); 
  // box-shadow: 0px 0px 9px 3px rgba(0, 0, 0, 0.1);
  display: block;
  // cursor: pointer;
  background: #fff;
  padding: 1rem;
`;

export default makeStyles(config);
